import React from 'react'
import { observer } from 'mobx-react-lite'

import Avatar from '@mui/material/Avatar'
import ListItem from '@mui/material/ListItem'
import ListItemAvatar from '@mui/material/ListItemAvatar'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import { useTheme } from '@mui/material/styles'

import { Text } from '@mxenabled/mxui'
import { Icon } from '@mxenabled/mx-icons'

import { ANALYTICS_EVENTS, Dialog, useGlobalCopyStore } from '../../../../../common'

import type { Transaction } from '../../../../../core'

import { useTransactionsUiStore } from '../../../../context/hooks'
import { useEvent, useTransactionStore } from '../../../../../common'
import { ON_CLICK_EVENTS } from '../../../../constants/OnClickEvents'

interface DeleteLogoActionProps {
  transaction: Transaction
}

const DeleteLogoAction: React.FC<DeleteLogoActionProps> = ({ transaction }) => {
  const { onEvent } = useEvent()
  const { updateTransaction } = useTransactionStore()
  const { setShouldDisableDrawerScroll } = useTransactionsUiStore()
  const { common: commonCopy, transactions: copy } = useGlobalCopyStore()
  const theme = useTheme()
  const [open, setOpen] = React.useState(false)

  const handleDeleteLogo = async () => {
    await updateTransaction({ ...transaction, merchant_guid: '' })
    onEvent(ANALYTICS_EVENTS.TRANSACTION_DETAILS_CLICK_DELETE_LOGO, {
      transaction_guid: transaction.guid,
    })
  }

  const bgColor = theme.palette.mode === 'dark' ? 'grey.800' : 'grey.100'

  return (
    <React.Fragment>
      {transaction && (
        <ListItem className="mx-txn-delete-logo" disableGutters={true} disablePadding={true}>
          <ListItemButton
            onClick={() => {
              onEvent(ON_CLICK_EVENTS.ON_TRANSACTION_DELETE_LOGO_CLICK)
              setOpen(true)
            }}
          >
            <ListItemAvatar>
              <Avatar sx={{ bgcolor: bgColor }} variant="rounded">
                <Icon name="delete" sx={{ color: 'text.primary' }} />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={copy.merchant_logo_title} secondary={copy.merchant_logo_desc} />
            <ListItemIcon>
              <Icon name="chevron_right" sx={{ color: 'text.primary' }} />
            </ListItemIcon>
          </ListItemButton>
          <Dialog
            copy={{ title: copy.merchant_logo_modal_title }}
            isOpen={open}
            onClose={() => {
              setShouldDisableDrawerScroll(false)
              setOpen(false)
            }}
            onPrimaryAction={handleDeleteLogo}
            onSecondaryAction={() => onEvent(ON_CLICK_EVENTS.ON_TRANSACTION_DELETE_LOGO_CANCEL)}
            primaryText={commonCopy.delete_button}
            secondaryText={commonCopy.cancel_button}
            title={copy.merchant_logo_modal_title}
          >
            <Text variant="subtitle1">{copy.merchant_logo_modal_desc}</Text>
            <Text bold={true} variant="subtitle1">
              {` ${copy.merchant_logo_modal_desc_bold}`}
            </Text>
          </Dialog>
        </ListItem>
      )}
    </React.Fragment>
  )
}

export default observer(DeleteLogoAction)
